import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, } from '@angular/material/dialog';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {
    SuccessCase,
    SuccessCase_Service,
    UserPermission_Service,
    WIP,
    SuccessContactWithType,
    Contact,
    AddressBookService,
    AddressBook,
    SuccessAccountFirm_Service,
    NotificationType_Service,
    Notification_Service,
    PagedResourceListComponent,
    SuccessCaseDataSource,
    SuccessContact,
    SuccessCaseContact,
    SuccessContact_Service,
    SuccessCaseContact_Service,
    SuccessAccountPermissionNodeName,
    SystemConfig_service,
    UserDevicePreferencesService
} from 'legalreflex-lib';
import { FormBuilder, } from '@angular/forms';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { CaseRestoreDialog } from '../restore/caseRestoreDialog';
import { BreadCrumbService } from '../../../components/breadcrumb-bar/breadcrumb-service';
import { ParticipantEditPopupDialog } from '../participantEdit/participantEdit';
import { combineLatest, Observable, of, Subject } from 'rxjs';
import { switchMap, takeUntil, tap } from 'rxjs/operators';
import { ResourceListPane } from '@smartsoftware/reflex-core';

@Component({ 
    templateUrl: './list.html',
    styleUrls: ['./list.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({height: '0px', minHeight: '0'})),
            state('expanded', style({height: '*'})),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})

export class CaseList extends PagedResourceListComponent<SuccessCase> {

    @ViewChild(MatSort) sort: MatSort = new MatSort();
    @ViewChild('contactSort') contactSort: MatSort = new MatSort();
    @ViewChild('filter') filterPane: ResourceListPane = new ResourceListPane();
    public filterCollapsed: boolean = sessionStorage.getItem("filterCollapsed") == 'true';

    public WIP : boolean = WIP()
    public userEmail: string = ''
    public userId: string = ''
    public isAdmin: boolean = false
    public isFirstLegal: boolean = false
    public activeContacts: Array<Contact[]> = [[],[],[]]
    public contactSource: MatTableDataSource<SuccessContactWithType> = new MatTableDataSource<SuccessContactWithType>()
    public contactEdit: SuccessContactWithType | null = null
    public isLoading: boolean =  true
    public courtAddress: AddressBook | null = null
    public expandedEntity: SuccessCase | null = null
    public noCaseFound: boolean = false
    public corpUsers: Map<string, string> = new Map<string, string>()
    public participantColumns = ['view', 'contactType', 'firstName', 'email', 'phone', 'companyName', 'address', 'city', 'state']
    public caseColumns = ['select', 'view', 'name', 'caseNumber', 'clientMatterNumber', 'successAccount_uuid']

    private _getCaseContacts$: Subject<Observable<any>> = new Subject<Observable<any>>();
    private _addressBookGet$: Subject<Observable<any>> = new Subject<Observable<any>>();
    private _deleteParticipant$: Subject<Observable<any>> = new Subject<Observable<any>>();
    private _editParticipant$: Subject<Observable<any>> = new Subject<Observable<any>>();
    private _deleteEntries$: Subject<Observable<any>> = new Subject<Observable<any>>();
    private _restoreEntry$: Subject<Observable<any>> = new Subject<Observable<any>>();
    private _destroy$: Subject<void> = new Subject<void>();

    constructor(
        public dataSource: SuccessCaseDataSource,
        public resourceService: SuccessCase_Service,
        public router: Router,
        public fb: FormBuilder,
        protected auth: OidcSecurityService,
        protected contactService: SuccessContact_Service,
        protected caseContactService: SuccessCaseContact_Service,
        protected route: ActivatedRoute,
        protected dialog: MatDialog,
        protected successAccountService: SuccessAccountFirm_Service,
        protected addressBookService: AddressBookService,
        protected notificationTypeService: NotificationType_Service,
        protected notificationService: Notification_Service,
        private userPermissionService: UserPermission_Service,
        private breadCrumbService: BreadCrumbService,
        public sysConfig: SystemConfig_service,
        public userDevicePreferences: UserDevicePreferencesService
    ) { 
        super(dataSource, resourceService, dialog, route, router)
        this.breadCrumbService.breadcrumbs.next([
            { label: 'Case Manager', url:'/case'},
            { label: 'History'}
        ])
        this.setBreadCrumbs()

        this.filterFormGroup = this.fb.group({
            name: '',
            caseNumber: '',
            clientMatterNumber: '',
            user: '',
            isRestricted: 'either',
            isDeleted: 'notDeleted',
            source: 'success',
        })
        this.filterFormGroup.patchValue(this.userDevicePreferences.fcFilter)
        Object.keys(this.dataSource.filters).map((key)=>{this.dataSource.filters[key] = this.userDevicePreferences.fcFilter[key]})
    }


    ngOnInit() {
        super.ngOnInit();
        if(this.sysConfig.maintenanceRedirectCheck()){  
            window.localStorage.removeItem("loggedInUserPermissionNodes");
            this.auth.logoff();
        };
        this.auth.userData$
            .pipe(
                switchMap(({ userData }) => {
                    let response = userData;
                    this.userId = response.profile.uuid;
                    this.userEmail = response.profile.email;
                    return this.userPermissionService.userSync.pipe(
                        tap(() => {
                            if (this.userPermissionService.hasRole(SuccessAccountPermissionNodeName.manage_all_cases_in_system)) {
                                this.isAdmin = true;
                                this.isFirstLegal = true;
                            } else if (this.userPermissionService.hasRole(SuccessAccountPermissionNodeName.manage_firm_cases)) {
                                this.isAdmin = true;
                            }
                        })
                    );
                }),
                takeUntil(this._destroy$)
            )
            .subscribe();

        this.successAccountService.list()
            .pipe(takeUntil(this._destroy$))
            .subscribe((res)=>{
                res.map((user)=>{
                    this.corpUsers.set(user.id.toString(), user.firstName + ' ' + user.lastName)
                })
            });

        this._getCaseContacts$
            .pipe(
                switchMap((getCaseContacts) => getCaseContacts),
                takeUntil(this._destroy$)
            )
            .subscribe();

        this._addressBookGet$
            .pipe(
                switchMap((getAddressBook) => getAddressBook),
                takeUntil(this._destroy$)
            )
            .subscribe();

        this._deleteParticipant$
            .pipe(
                switchMap((deleteParticipant) => deleteParticipant),
                takeUntil(this._destroy$)
            )
            .subscribe();

        this._editParticipant$
            .pipe(
                switchMap((editParticipant) => editParticipant),
                takeUntil(this._destroy$)
            )
            .subscribe();

        this._deleteEntries$
            .pipe(
                switchMap((deleteEntries) => deleteEntries),
                takeUntil(this._destroy$)
            )
            .subscribe();

        this._restoreEntry$
            .pipe(
                switchMap((restoreEntry) => restoreEntry),
                takeUntil(this._destroy$)
            )
            .subscribe();

        this.dataSource.sort = this.sort
        this.dataSource.pageSize = 25

    }

    ngAfterViewInit() {
        super.ngAfterViewInit()
        setTimeout(() => {
            this.filterFormGroup!.valueChanges.pipe(takeUntil(this._destroy$)).subscribe((jsonObject)=>{
                this.userDevicePreferences.fcFilter = jsonObject;
            })
            if (this.dataSource.sort) {
                this.dataSource.sort.active = 'name'
                this.dataSource.sort.direction = 'asc'
            }
            this.getCases()
            let filterClick = document.getElementById('filterPaneCase');
            if(filterClick && !filterClick.hasAttribute('filterClickAttached')){
                this.filterPaneClick(filterClick, this.filterPane);
            }
        })
        this.dataSource.loading.pipe(takeUntil(this._destroy$)).subscribe((state)=>{
            this.isLoading = state
            document.getElementById('filterPaneCase')?.click()
        })
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this._destroy$.next();
        this._destroy$.complete();
    }

    sortDatasource(event: any){
        if(event == 'case'){
            this.selection.clear()
            this.setBreadCrumbs()
        }
        else
            this.contactSource.data = this.contactSource.sortData(this.contactSource.data,this.contactSort)
    }

    selectionChange(event?:any){
        if(event){
            event.stopPropagation()
        }
        // To fire after selection update goes through
        setTimeout(() => {
            this.setBreadCrumbs()   
        })
        
    }

    checkSelected(entity: SuccessCase): boolean {
        const selected = this.selection.selected.map((e) => e.uuid);
        if (selected.includes(entity.uuid)) return true;
        return false;
    }

    updateSelection(entity: SuccessCase) {
        const item = this.selection.selected.find((e) => e.uuid === entity.uuid);
        if (item) {
            this.selection.deselect(item);
        } else {
            this.selection.select(entity);
        }
    }

    pageChange(event:any){
        this.setBreadCrumbs()
    }

    setBreadCrumbs(){

        let actions = []
        actions.push({label: 'Refresh', action:this.getCases.bind(this,false), icon: 'refresh'})
        if(!this.selection.isEmpty()){
            actions.push({label: 'Delete Case(s)', action:this.deleteEntries.bind(this), icon: 'delete'})
        }else{
            actions.push({label: 'Delete Case(s)', disabled:true, icon: 'delete', tooltip:"Please select 1 or more cases."})
        }
        actions.push({label: 'New Case', routerLink: "/case/new", isPrimary: true, icon: 'library_add'})
        this.breadCrumbService.actions.next(actions)
    }

    getCases(reset?: boolean){
        if(reset){
            this.filterFormGroup?.patchValue({
                name: '',
                caseNumber: '',
                clientMatterNumber: '',
                user: '',
                isRestricted: 'either',
                isDeleted: 'notDeleted',
                source: 'success',
            })
        }


        if(this.filterFormGroup?.get('isDeleted') && this.filterFormGroup?.get('isDeleted')?.value)
            this.filterFormGroup!.get('isDeleted')?.setValue(this.filterFormGroup!.get('isDeleted')?.value)
        else if(this.filterFormGroup?.get('isDeleted'))
            delete this.filterFormGroup?.controls['isDeleted']

        this.onFilterSubmit()
        this.selection.clear()
        this.setBreadCrumbs()
    }

    getEntity(entity:SuccessCase){
        this.expandedEntity = this.expandedEntity === entity ? null : entity
        if(this.expandedEntity == null)
            return
        this.courtAddress = null
        this.contactSource.data = []
        this._getCaseContacts$.next(
            this.resourceService.getCaseContacts(entity.uuid).pipe(
                tap((contacts) => {
                    this.contactSource.data = this.contactSource._filterData(contacts.slice(0, 11));
                })
            )
        ); 
        if(entity.court_AddressBook_uuid)
            this._addressBookGet$.next(
                this.addressBookService.get(entity.court_AddressBook_uuid).pipe(
                    tap((res) => {
                        this.courtAddress = res;
                    })
                )
            );
    }

    deleteParticipant(entity:SuccessContactWithType){
        this._deleteParticipant$.next(
            this.caseContactService.search({ where: { filters: { uuid: entity.caseContact_uuid } } }).pipe(
                switchMap((res) => {
                    let entry = res.results[0];
                    entry.isDeleted = true;
                    entry.deletedAt = new Date();
                    return this.caseContactService.push(entry).pipe(
                        tap(() => {
                            let data = this.contactSource.data.filter((contact) => {
                                return contact.uuid != entry.contact_uuid;
                            });
                            this.contactSource.data = this.contactSource._filterData(data);
                        })
                    );
                })
            )
        );
    }

    editParticipant(participant?:SuccessContactWithType){
        let expanded = this.expandedEntity?.uuid
        if(!expanded)
            return
        let entity : SuccessContactWithType = {uuid:"", }
        if(participant)
            entity = participant

        this._editParticipant$.next(
            this.dialog
            .open(ParticipantEditPopupDialog, {
                data: entity,
            })
            .afterClosed()
            .pipe(
                switchMap((saved: SuccessContactWithType | undefined) => {
                    if (saved && saved.isOrganization == true) {
                        saved.firstName = undefined;
                        saved.lastName = undefined;
                    }
                    if (saved) {
                        if (!saved.uuid) {
                            let contact = new SuccessContact();
                            let caseContact = new SuccessCaseContact();
                            Object.assign(contact, saved);
                            return this.contactService.push(contact).pipe(
                                switchMap((newContact: SuccessContact) => {
                                    Object.assign(caseContact, {
                                        case_uuid: expanded,
                                        contact_uuid: newContact.id.toString(),
                                        contactType: saved.contactType,
                                    });
                                    return this.caseContactService.push(caseContact).pipe(
                                        tap((res) => {
                                            saved.caseContact_uuid = res.id.toString();
                                            this.contactSource.data.push(saved);
                                            this.contactSource.data = this.contactSource.sortData(this.contactSource.data, this.contactSort);
                                        })
                                    );
                                })
                            );
                        } else if (saved.uuid) {
                            let contact = new SuccessContact();
                            Object.assign(contact, saved);
                            return this.contactService.push(contact).pipe(
                                tap((editedContact: SuccessContact) => {
                                    let dataInd = this.contactSource.data.findIndex((participant) => participant.uuid == saved.uuid);
                                    this.contactSource.data[dataInd] = saved;
                                    this.contactSource.data = this.contactSource.sortData(this.contactSource.data, this.contactSort);
                                })
                            );
                        }
                    }
                    return of(null);
                })
            )
        );
    }

    deleteEntries(){
        this._deleteEntries$.next(
            this.openConfirmDeleteDialog().pipe(
                switchMap((response) => {
                    if (response.confirmed) {
                        let observables = this.selection.selected.map((selectedCase) => {
                            selectedCase.deletedAt = new Date();
                            selectedCase.isDeleted = true;
                            return this.resourceService.updateCase(selectedCase);
                        });
                        this.isLoading = true;
                        return combineLatest(observables).pipe(
                            tap(
                                () => {
                                    this.selection.clear();
                                    this.setBreadCrumbs();
                                    this.getCases();
                                },
                                (error) => this.openErrorDialog(error)
                            )
                        );
                    }
                    return of(null);
                })
            )
        );
    }

    restoreEntry(entity: any){
        this._restoreEntry$.next(
            this.dialog
                .open(CaseRestoreDialog, {
                    data: entity,
                })
                .afterClosed()
                .pipe(
                    switchMap((res) => {
                        if (res) {
                            entity.deletedAt = null;
                            entity.isDeleted = false;
                            return this.resourceService.updateCase(entity);
                        }
                        return of(null);
                    })
                )
        );
    }

    public search() {
        this.onFilterSubmit();
        this.dataSource.reload();
    }

    public getPrimaryUser(uuid: string): string {
        let res = this.corpUsers.get(uuid);
        if(res == undefined){
            this.corpUsers.set(uuid, "");
            this.getPrimaryUserName(uuid)
            return "";
        }
        return res;
    }

    //Secondary user name check.
    public getPrimaryUserName(uuid: string){
        this.successAccountService.get(uuid).subscribe(r => {
            if(r) this.corpUsers.set(uuid, `${r.firstName} ${r.lastName}`.trim());
        });
    }
}
